/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Copy_Raw_SuccessInputs */



/**
* | output |
* | --- |
* | "Markdown copied to clipboard" |
*
* @param {Editor_Copy_Raw_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_copy_raw_success = /** @type {((inputs?: Editor_Copy_Raw_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Copy_Raw_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Markdown in Zwischenablage kopiert")
	return /** @type {LocalizedString} */ ("Markdown copied to clipboard")
});